import { Pipe, PipeTransform } from '@angular/core';
import { ImageService } from '../services/image.service';
import { environment } from 'environments/environment';
import { User } from '../contracts/models/user.model';
import { Customer } from '../contracts/models/customer';
import { UserLegacy } from '../contracts/models/usuario.model';
import { Media } from '../contracts/models/media.interface';

@Pipe({
    name: 'image'
})
export class ImagePipe implements PipeTransform {

    private url: string = environment.app_urls.source;
    private readonly builders: Record<string, (data: any) => string> = {
        user: (d: any) => `${this.url}/api/users/data/displayImage/${d.id}`,
        customer: (d: any) => `${this.url}/api/clientes/data/displayImage/${d.id}?timeStamp=${Date.now()}`,
        medio: (d: any) => `${this.url}/api/medios/data/displayImage/${d.id}?timeStamp=${Date.now()}`,
        tenant: (d: any) => `${this.url}/api/tenants/displayImage/${d.id}?timeStamp=${Date.now()}`,
        tenant_escudo: (d: any) => `${this.url}/api/tenants/displayImageEscudo/${d.id}?timeStamp=${Date.now()}`,
        resultado: (d: any) => `${this.url}/api/resultadoPlataformas/data/displayImage/${d}`,
        resultadoImage: (d: any) => `${this.url}/api/resultadoPlataformas/data/displayImageResultado/${d.id}`,
    };

    constructor(private imageService: ImageService) { }

    async transform(data: UserLegacy | Customer | Media | User | any, type?: string): Promise<string> {
        try {
            if (!type || !this.builders[type]) {
                return 'assets/images/noimage.png';
            }
            const endpoint = this.builders[type](data);
            const result = await this.imageService.getUrl(endpoint);
            if (result?.url) {
                return result.url;
            }
            const blob = await this.imageService.get(endpoint);
            if (blob) {
                return await this.blobToBase64(blob);
            }
            return type === 'user' ? 'assets/images/default-avatar.png' : 'assets/images/noimage.png';
        } catch (error) {
            return type === 'user' ? 'assets/images/default-avatar.png' : 'assets/images/noimage.png';
        }
    }

    private blobToBase64(blob: Blob): Promise<string> {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
        });
    }
}
